export enum ECollection {
    LM_USERS = 'lm_users',
}
